// extracted by mini-css-extract-plugin
export default {"body":"parkingZoneOwnershipRequsetModal_body__xYdw6"};